import {PartnerClient} from '../../client/partner-client'
import {Popup} from '../common/popup/popup'
import {MessageBox} from '../message-box'
import {useInput} from '../../containers/hooks'
import {globals} from '../../extensions/globals-base'
import * as React from 'react'
import {Util} from 'yougile-util'
import {getTotalPartnerEarnings, User} from 'yougile-model'
import {Backend} from '../../../common/backend'
import {Sync} from '../../client/sync'

interface Props {
  close(): void
}

// eslint-disable-next-line max-lines-per-function
export const PartnerWithdrawPopup = (props: Props) => {
  const {close} = props
  const bem = Util.bemFrom('partner-withdraw-popup')
  const [error, setError] = React.useState('')
  const [amount, changeAmount] = useInput('', () => setError(''))
  const [phone, changePhone] = useInput(globals.phone, () => setError(''))
  const user = Sync.getProfile().get(globals.currentUserId) as User
  const [email, changeEmail] = useInput(user.email, () => setError(''))
  const [loading, setLoading] = React.useState(false)
  const data = PartnerClient.data
  const sum = getTotalPartnerEarnings(data)
  const available = sum - data.withdrawn
  const submit = async () => {
    if (!+amount || +amount < 0) {
      setError('Некорректная сумма вывода')
      return
    }
    if (+amount > available) {
      setError(`Доступно ${available} р.`)
      return
    }
    if (!Util.isPhone(phone)) {
      setError(`Укажите телефон для связи`)
      return
    }
    if (!Util.isEmail(email)) {
      setError(`Укажите e-mail для связи`)
      return
    }

    setLoading(true)
    const res = await Backend.postJSON('/data/partner/withdraw', {
      ...Backend.loadCred(),
      phone,
      email,
      amount
    }).catch(_ => ({result: 'error', error: 'Network failure'}))

    if (res.result === 'ok') {
      MessageBox.show(
        'Запрос успешно отправлен, менеджер свяжется ' +
          'с вами для вывода средств',
        'success'
      )
      close()
    } else {
      MessageBox.show(
        `Произошла ошибка ${res.error}, пожалуйста, обратитесь в поддержку`,
        'danger'
      )
    }
    setLoading(false)
  }

  return (
    <Popup
      close={close}
      footer={null}
      title="Запрос вывода средств"
      width={320}
      autoHeight={true}
      className={bem('popup')}
    >
      <div className={bem('form')}>
        <div className={bem('title')}>
          Для вывода доступно <b>{available}</b> р.
        </div>
        <input
          className={bem('input')}
          type="number"
          placeholder="Сумма для вывода (руб.)"
          value={amount}
          onChange={changeAmount}
        />
        <input
          className={bem('input')}
          type="text"
          placeholder="E-mail для связи"
          value={email}
          onChange={changeEmail}
        />
        <input
          className={bem('input')}
          type="text"
          placeholder="Телефон для связи"
          value={phone}
          onChange={changePhone}
        />
        {!!error && <div className={bem('error')}>{error}</div>}
        {loading ? (
          <div className={bem('loading')} />
        ) : (
          <div className={bem('btn')} onClick={submit}>
            Вывести
          </div>
        )}

        <div className={bem('explain')}>
          Менеджер свяжется с вами для вывода партнёрского вознаграждения
        </div>
      </div>
    </Popup>
  )
}
